var map = {
	"./BackLeft.jpg": 328,
	"./BackRight.jpg": 329,
	"./BoardMarking.jpg": 330,
	"./Custom.jpg": 331,
	"./Damage.jpg": 332,
	"./DamagedWindowBrand.jpg": 333,
	"./FrontLeft.jpg": 334,
	"./FrontRight.jpg": 335,
	"./KM.jpg": 336,
	"./RegNumber.jpg": 337,
	"./Regnummer.jpg": 338,
	"./Rudelabel.jpg": 339,
	"./Rudelebel.jpg": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;